import axios from 'axios'
import config from './config'
import { Toast, Dialog } from 'vant'
import { formatSearch } from '@/utils/util'
import store from '@/store/index'
if (window.location.search) {
  formatSearch(window.location.search)
}
let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
let reqCount = 0
const instance = axios.create({
  baseURL: config.baseURL,
  headers: {
    // 'session-id': 'bc6590cfb95049e592a9fa56f50608fa',
    'session-id': userInfo.token || '',
    'Content-Type': 'application/json'
  },
  timeout: 30 * 1000
})

// 添加请求拦截器
instance.interceptors.request.use(
  function(config) {
    // 在发送请求之前做些什么
    if (!config.loadingDisable) {
      store.commit('showLoading')
    }
    reqCount += 1

    // vuex记录cancelToken
    config.cancelToken = new axios.CancelToken(cancel => {
      store.commit('pushToken', {
        cancelToken: cancel
      })
    })
    return config
  },
  function(error) {
    // 对请求错误做些什么、
    reqCount--
    if (!reqCount) {
      store.commit('hideLoading')
    }
    return Promise.reject(error)
  }
)

// 添加响应拦截器
instance.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么
    reqCount--
    if (!reqCount) {
      store.commit('hideLoading')
    }
    if (response.data.code === 1) {
      // Toast.fail({
      //   message: response.data.msg,
      //   forbidClick: true,
      //   duration: 1000
      // })
    }
    return response.data
  },
  function(error) {
    // 对响应错误做点什么
    reqCount--

    if (error.message === '路由跳转取消请求') {
      // 判断是否为路由跳转取消网络请求
      console.log('路由跳转取消请求' + error)
    } else {
      if (!reqCount) {
        store.commit('hideLoading')
      }
      if (error.response) {
        if (error.response.status === 401) {
          // token失效
          Toast.fail({
            message: '登录失效，请稍后...',
            forbidClick: true,
            duration: 1000,
            onClose: () => {
              window.location.href = config.env
                ? 'https://wechat.tengzone.com/weixin_business_core/mp/page/auth/access?wechatId=tysqxiamen&bizType=SEND_EXPRESS&url=https://wechat-h5.tengzone.com/home'
                : 'https://tweixin.tengzone.com/weixin_business_core/mp/page/auth/access?wechatId=tengyunbaotest&bizType=SEND_EXPRESS&url=https://test-send-h5.tengzone.com/home'
            }
          })
        } else {
          // 其他错误处理
          Toast.fail({
            message:
              error.response.data.msg || '请求错误' + error.response.status,
            forbidClick: true
          })
        }
      }
      if (error.message.includes('timeout')) {
        Dialog.alert({
          title: '提示',
          message: '当前网络不佳，请重新刷新一下哦~'
        })
      }
      console.log(error.response)
      return Promise.reject(error.response)
    }
  }
)

export default instance
